import axios from 'axios'

const basePath = '/motor-assessment/api/service-providers/windscreen-fitters'

const unwrap = (response) => {
  const result = response?.data

  if (result?.success !== true) {
    const error = new Error(
      result?.msg || 'The windscreen fitter request failed'
    )
    error.response = response
    throw error
  }

  return result.data
}

export const listWindscreenFitters = (limit = 10, offset = 0) =>
  axios
    .get(basePath, {
      params: { limit, offset },
    })
    .then(unwrap)

export const createWindscreenFitter = (payload) =>
  axios.post(basePath, payload).then(unwrap)

export const updateWindscreenFitter = (id, payload) =>
  axios.put(`${basePath}/${encodeURIComponent(id)}`, payload).then(unwrap)

export const disableWindscreenFitter = (id, updatedBy) =>
  axios
    .patch(`${basePath}/${encodeURIComponent(id)}/disable`, { updatedBy })
    .then(unwrap)

export const activateWindscreenFitter = (id, updatedBy) =>
  axios
    .patch(`${basePath}/${encodeURIComponent(id)}/activate`, { updatedBy })
    .then(unwrap)

export default {
  listWindscreenFitters,
  createWindscreenFitter,
  updateWindscreenFitter,
  disableWindscreenFitter,
  activateWindscreenFitter,
}
